import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import HeroMb from '../../../images/solutions/hero-mb.png';
import Hero from '../../../images/solutions/hero.png';
import { MainStyled, TextColumn, Title, Subtitle, ImageColumn } from './style';

interface Props {}

const Main: FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <MainStyled>
      <div className="container">
        <TextColumn className="animate__animated animate__fadeIn">
          <Title>{t('SolutionMainTitle')}</Title>
          <Subtitle
            dangerouslySetInnerHTML={{
              __html: t('SolutionMainSubtitle'),
            }}
          />
        </TextColumn>
        <ImageColumn className="animate__animated animate__fadeIn">
          <img src={Hero} alt="background" />
          <img src={HeroMb} alt="background" />
        </ImageColumn>
      </div>
    </MainStyled>
  );
};

export default Main;
